<template>
  <div class="document-discussions">
    <a
      v-if="document.newDiscussionUrl"
      class="document-discussions__link"
      target="_blank"
      :href="document.newDiscussionUrl"
    >
      Создать новое обсуждение этого документа на сайте normacs.info
    </a>
    <a
      v-if="discussion"
      class="document-discussions__link"
      :href="discussion.url"
      target="_blank"
    >
      Перейти к обсуждениям этого документа на сайте normacs.info
    </a>
    <div class="document-discusssions__loaded">
      <div class="document-discusssions__loaded-title">
        <span v-if="discussion">
          Cохраненная копия обсуждений с сайта normacs.info от
          {{ discussion.commentsDate | formatDate }}
        </span>
        <span v-else>Этот документ еще не обсуждался</span>
      </div>
      <list-items-loadable
        ref="comments"
        v-slot="{ item: comments }"
        :items="discussionItems"
        css-class="document-discussions__list"
        empty-text=""
      >
        <list-items
          v-slot="{ item }"
          :items="comments"
          :expandable="1"
          css-class="document-discussion"
        >
          <a
            :href="item.url"
            target="_blank"
            class="document-discussion__item-header"
          >
            <span>
              {{ item.author }}
            </span>
            <time class="document-discussion__item-date">
              {{ item.date | formatDate }}
            </time>
          </a>
          <div class="document-discussion__item-text" v-html="item.text"></div>
        </list-items>
      </list-items-loadable>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

import ListItems from '@@/shared/list/ListItems';
import ListItemsLoadable from '@@/shared/list/ListItemsLoadable';

import NormaCsLinkHandler from '@@/document/mixins/NormaCsLinkHandler';

export default {
  components: {
    ListItems,
    ListItemsLoadable
  },

  mixins: [NormaCsLinkHandler],

  props: {
    /** @type {Object|ApiDocumentCard} */
    document: {
      type: Object,
      required: true
    }
  },

  computed: {
    ...mapGetters({
      discussionItems: 'currentDocumentDiscussions'
    }),
    /** @returns {ApiDocumentDiscussion|null} */
    discussion() {
      return this.document.discussion;
    }
  },

  mounted() {
    this.initNormaCsLinkHandler(this.$refs.comments.$el);
  }
};
</script>
